// Action Helper
export const createActionWithState = (actionType, prepareAction) => {
    const actionCreator = (...params) => (dispatch, getState) => {
        dispatch({
            type: actionType,
            ...prepareAction(getState(), ...params)
        })
    };

    actionCreator.toString = () => actionType;

    return actionCreator;
};
